<script setup lang="ts">
// TODO: make prop required once /[line]/[slug] has skeletons (not nullable)
const props = defineProps<{
  setNid?: number
}>()

const { locale } = useI18n()

const { data: smartFiltersData, status } = await useLazyAsyncData(
  'smartFilters_' + props.setNid + '_' + locale.value,
  () => createProductSetsRepository().getAllSmartFiltersByNid(props.setNid),
  {
    default: defaultPaginationObject,
  }
)

const smartFilters = computed(() => smartFiltersData.value.items)
</script>

<template>
  <UiSection
    :title="$t('base.products.includedInCollections')"
    v-if="status !== 'error' && smartFilters.length"
  >
    <ProductsFiltersSmartGrid :smart-filters="smartFilters" :status="status" />
  </UiSection>
</template>
